<template lang="pug">
    .settings(v-if='settings')
        template(v-if="parametersFrom === 'homework'")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.amountOfExamples }}
            br
            template
                | {{ $i18n.t('trainer.trainer_gameForm_randomDate') }}:
                | {{ isRandomDate() }}
                template(v-if='settings.isLeapYear')
                    br
                    span
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_leapYear') }}:
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
                br
</template>

<script>
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: {
            game: {
                type: Object,
                default() {},
            },
            parameters: {
                type: Object,
                default() {},
            },
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: {
                type: Number,
                default: 0,
            },
        },
        mixins: [gamePreviewMixin],
        methods: {
            isRandomDate() {
                return this.settings.randomDate
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_on')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
            },
        },
    };
</script>
